import { factory } from   '../../../utils/apiThunkFactory';
export const countAllUsersByTenant = factory.get('admin/getLivekitUrl', '/api/admin/countUsers');
export const countConnectedUsersByTenant = factory.get('admin/countConnectedUsersByTenant', '/api/admin/connected');
export const countConnectedGuestByTenant = factory.get('admin/countConnectedGuestByTenant', '/api/admin/connectedGuests');
export const filterUser = factory.post('admin/filterUser', '/api/admin/users');
export const AddUser = factory.post('admin/AddUser', '/api/admin/adduser');
export const UpdateUser = factory.put('admin/UpdateUser', '/api/admin/updateUser/:email');
export const DeleteUser = factory.delete('admin/DeleteUser', '/api/admin/users/:email');
export const updateSttModel = factory.put('admin/updateSttModel', '/api/tenants/stt-model');
